import React, {ReactNode, useEffect} from "react";
import TimeoutIdleTimer from "./toolkit/TimeoutIdleTimer";
import {useAppUniqueToken} from "../hooks/useAppUniqueToken";
import {authLocalStorage} from "../config/global";
import {useAuthLocalStorage} from '../hooks/useAuthLocalStorage';

interface IProps {
    children: ReactNode;
    path: string
}

const Layout = ({ children, path, ...props }: IProps)  => {
    const { checkAppUniqueTokenOnStartup, removeAppUniqueToken } = useAppUniqueToken();

    useEffect(() => {

        //console.log('LAYOUT - useEffect -> checkAppUniqueTokenOnStartup: '+ path);
        checkAppUniqueTokenOnStartup(path);

    }, []);

    const {getAuthLocalStorageKey} = useAuthLocalStorage();

    useEffect(() => {

        //console.log('LAYOUT - path: ' + path)
        //console.log('LAYOUT - ' + authLocalStorage.authKey +': ' + getAuthLocalStorageKey())

    }, [path]);



    return (
        <>
            <TimeoutIdleTimer isAuthenticated={getAuthLocalStorageKey()} logOut={removeAppUniqueToken} />
            {children}
            <div className="footer">
                <div className="container py-2 copy">© Europa Verde</div>
            </div>
        </>
    );
};

export default Layout;
